import styles from './style.module.css';

type Accent = 'biz' | 'engage';
type Size = 'normal' | 'big' | 'huge';

type Props = {
  label: string;
  value: string;
  foot?: string;
  category?: string;
  accent?: Accent;
  size?: Size;
};

export function KPI({ label, value, foot, category, accent, size = 'big' }: Props) {
  const classes = [styles.kpi, accent ? styles[accent] : ''].filter(Boolean).join(' ');
  const valueClasses = [styles.value, size === 'big' ? styles.big : size === 'huge' ? styles.huge : ''].filter(Boolean).join(' ');
  return (
    <div className={classes}>
      {accent && <div className={styles.accent} />}
      {category && <div className={styles.category}>{category}</div>}
      <div className={styles.label}>{label}</div>
      <div className={valueClasses}>{value}</div>
      {foot && <div className={styles.foot}>{foot}</div>}
    </div>
  );
}
